// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gfJ-","left":"styles_left__345W0","desktopActions":"styles_desktopActions__3bnr5","title":"styles_title__mxZQT"};